import { ChangeEvent, KeyboardEvent, MouseEvent, SyntheticEvent, memo, useRef } from 'react';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useFormContext } from 'react-hook-form';
import Stack from '@mui/material/Stack';
import { TextField, Typography } from '@mui/material';

import { IStyledDatePicker } from './types';
import { adjustDateForTimeZone } from './helpers';

const StyledDatePicker = ({ name, label }: IStyledDatePicker) => {
  const { watch, setValue, register, formState: { isSubmitted } } = useFormContext();

  const watchedDate = watch(name);

  const datePickerRef = useRef<DatePicker>(null);

  const handleDateChange = (date: Date | null) => {
    // Adjust for Armenia Standard Time (GMT+4)
    // Convert to UTC ISO String
    const adjustedDate = date && adjustDateForTimeZone(date);
    const utcDateString = adjustedDate?.toISOString() || '';

    setValue(name, utcDateString, { shouldValidate: isSubmitted });
  };

  return (
    <Stack direction="row">
      <Stack gap="5px">
        <DatePicker
          ref={datePickerRef}
          selected={watchedDate ? new Date(watchedDate) : null}
          onChange={handleDateChange}
          customInput={(
            <TextField
              {...register('minRead')}
              label={label}
            />
          )}
        />
      </Stack>

    </Stack>
  );
};

export default memo(StyledDatePicker);
